export var useSubmit = function (submitFn) {
    return function (event) {
        event.preventDefault();
        var formData = new FormData(event.currentTarget);
        var curatedFormData = Object.fromEntries(formData.entries());
        var transformedData = curatedFormData;
        return submitFn(transformedData);
    };
};
